'use client';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';

import ImageWithFallback from '@/components/ImageWithFallback/ImageWithFallback';
import { UserSponsor } from '@/types/players.types';
import { getSponsorImageByPriority } from '@/utils/helpers/getSponsorImageByPriority';

interface OtherSponsorsProps {
  sponsors: UserSponsor[];
}

const OtherSponsors = ({ sponsors }: OtherSponsorsProps) => {
  return (
    <div className='flex flex-col'>
      <div className='flex px-4 sm:px-8 py-3 items-center text-lg sm:text-xl text-white font-bold sm:font-semibold rounded-t-lg bg-[linear-gradient(45deg,#6941C6_0%,#7F56D9_100%)] leading-4 sm:leading-0'>
        Other Sponsors
      </div>
      <div className='flex h-auto items-center justify-center rounded-b-lg border border-gray-300 py-6 px-2 sm:p-6 sm:min-h-[240px] bg-white'>
        <div className='grid grid-cols-3 gap-2 lg:grid-cols-5 lg:gap-6'>
          {sponsors.map((sponsor) => (
            <div
              key={sponsor.uuid}
              className='size-[90px] rounded border border-gray-300 md:size-[165px] bg-white'
            >
              {sponsor.sponsorImages ? (
                sponsor.url ? (
                  <a
                    href={sponsor.url}
                    target='_blank'
                    className='size-full'
                    aria-label={`Link to ${sponsor.title} page (opens in a new tab)`}
                    rel='noreferrer'
                  >
                    <ImageWithFallback
                      alt={`${sponsor.title} Logo`}
                      width={200}
                      height={200}
                      className='size-full object-contain p-2'
                      src={
                        getCDNURL(
                          getSponsorImageByPriority(sponsor.sponsorImages)?.url || '',
                          400,
                          400
                        ) || undefined
                      }
                    />
                  </a>
                ) : (
                  <ImageWithFallback
                    alt={`${sponsor.title} Logo`}
                    width={200}
                    height={200}
                    className='size-full object-contain p-2'
                    src={
                      getCDNURL(
                        getSponsorImageByPriority(sponsor.sponsorImages)?.url || '',
                        400,
                        400
                      ) || undefined
                    }
                  />
                )
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OtherSponsors;
